import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=ca384d8c&scoped=true&"
import script from "./Authentication.vue?vue&type=script&lang=ts&"
export * from "./Authentication.vue?vue&type=script&lang=ts&"
import style0 from "./Authentication.vue?vue&type=style&index=0&id=ca384d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca384d8c",
  null
  
)

export default component.exports